import type { U3141ChildLotChain } from '../U3141Service';

/**
 * Payload POST updateFromGraph (BL-0697) : omet district/cadastre vides ;
 * date d'établissement vide → `null` pour effacer en base (omettre = conserver l'ancienne valeur).
 */
export function u3141MapChildLotChainToGraphUpdatePayload(child: U3141ChildLotChain): U3141ChildLotChain {
  const ld = child.lotDetail;
  if (!ld) return child;

  const lotDetail: NonNullable<U3141ChildLotChain['lotDetail']> = {
    ...ld,
    lot: ld.lot ?? '',
    concordance: ld.concordance ?? [],
  };

  if (!ld.district?.id) {
    delete (lotDetail as { district?: unknown }).district;
  }
  if (!ld.cadastre?.id) {
    delete (lotDetail as { cadastre?: unknown }).cadastre;
  }
  if (!ld.dateEstablishment || String(ld.dateEstablishment).trim() === '') {
    lotDetail.dateEstablishment = null;
  }

  return {
    ...child,
    lotDetail,
  };
}
